import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const DashboardModule = new Module({
  id: 'DASHBOARD:VIEW:*',
  name: 'Dashboard',
  label: 'Dashboard',
  path: 'dashboard',
  isNew: true,
  Component: ComponentLoader(lazy(() => import('./CentralDashboard')))
});

export const DeploymentDashboardModule = new Module({
  id: 'DEPLOYMENT_DASHBOARD:VIEW:*',
  name: 'Deployment Dashboard',
  label: 'Deployment Dashboard',
  path: 'deployment-dashboard',
  Component: ComponentLoader(lazy(() => import('./DashboardV2'))),
  actions: {
    exportData: {
      id: 'DEPLOYMENT_DASHBOARD:ACTION:EXPORT_DATA',
      name: 'export-data',
      label: 'Export Data'
    }
  }
});

export const OrderDashboardModule = new Module({
  id: 'ORDER_DASHBOARD:VIEW:*',
  name: 'Order Dashboard',
  label: 'Order Dashboard',
  path: 'order-dashboard',
  Component: ComponentLoader(lazy(() => import('./OrderDashboard'))),
  actions: {
    exportData: {
      id: 'ORDER_DASHBOARD:ACTION:EXPORT_DATA',
      name: 'export-data',
      label: 'Export Data'
    }
  }
});

export const ServiceDashboardModule = new Module({
  id: 'SERVICE_DASHBOARD:VIEW:*',
  name: 'Service Dashboard',
  label: 'Service Dashboard',
  path: 'service-dashboard',
  Component: ComponentLoader(lazy(() => import('./ServiceDashboard'))),
  actions: {
    exportData: {
      id: 'SERVICE_DASHBOARD:ACTION:EXPORT_DATA',
      name: 'export-data',
      label: 'Export Data'
    }
  }
});

// Re-exported from reports for backward compatibility
export { StationDashboardModule } from 'src/content/reports/SessionReport/StationDashboard/module';

const DashboardModules = [
  DashboardModule,
  DeploymentDashboardModule,
  OrderDashboardModule,
  ServiceDashboardModule
];

export default new ModuleBundle('Dashboard', DashboardModules);
